<div class="container-fluid mb-2">
    <div class="row mt-2">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>{{'PROPERTIES.Neproknjiženi dokumenti' | translate}}</h5>
                </div>

                <div class="card-body">
                    <div class="common-fiwe">
                        <div class="recent-table table-responsive custom-scrollbar invoice-table">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>
                                            {{"PROPERTIES.Firma" | translate}}
                                        </th>
                                        <th>
                                            {{"PROPERTIES.Adresa" | translate}}
                                        </th>
                                        <th>
                                            {{"PROPERTIES.Broj dokumenata" | translate}}
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let item of documents; index as i" class="dms-lists">
                                        <td (click)="firmaClicked(item)">
                                            <p class="c-o-light">{{ item?.naziv }}</p>
                                        </td>

                                        <td (click)="firmaClicked(item)">
                                            <p class="c-o-light">{{ item?.firmeInformacije?.adresa }}</p>
                                        </td>

                                        <td (click)="firmaClicked(item)">
                                            <p class="c-o-light">{{ item?.unregistered }}
                                                @if (item?.error) {
                                                {{ item?.error }}
                                                }
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div *ngIf="loading" class="loader-box">
                                <div class="loader-2"></div>
                            </div>

                            @if (showZatvori) {
                            <div class="col-12 mt-4 text-end">
                                <button class="btn btn-light btn-sm" type="button" (click)="forceCloseModal()">
                                    {{ "PROPERTIES.Zatvori" | translate }}
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>